// Privacy API Initialization Only
// This file initializes Shopify's Customer Privacy API
// The consent banner UI is handled by Shopify's default banner

window.Shopify.loadFeatures(
	[
		{
			name: 'consent-tracking-api',
			version: '0.1',
		}
	],
	function(error) {
		if (error) {
			throw error;
		}
		
		// Privacy API is now loaded and ready
		// Custom event to signal that tracking scripts can initialize
		document.dispatchEvent(new CustomEvent('shopify:privacy_api_ready'));
	}
);